import { useState } from "react";

import { Button } from "@/design-system";
import { usePasswordResetRequestMutation } from "@/api/queries";
import { useScreenTitle } from "@/lib/use-screen-title";

import { AuthLayout } from "./AuthLayout";
import { Field } from "./Field";

export interface ForgotPasswordProps {
  onBack: () => void;
  onLogin: () => void;
}

export function ForgotPassword({ onBack, onLogin }: ForgotPasswordProps) {
  useScreenTitle("Reimposta password");
  const [email, setEmail] = useState("");
  const reset = usePasswordResetRequestMutation();

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    reset.mutate({ email: email.trim().toLowerCase() });
  }

  if (reset.isSuccess) {
    return (
      <AuthLayout
        title="Controlla la tua email"
        subtitle="Se l'indirizzo è registrato, abbiamo inviato un link per scegliere una nuova password. Il link scade fra un'ora."
        onBack={onBack}
      >
        <Button variant="ghost" full onClick={onLogin}>
          Torna al login
        </Button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Hai dimenticato la password?"
      subtitle="Inserisci la tua email — ti invieremo un link per scegliere una nuova password."
      onBack={onBack}
    >
      <form onSubmit={handleSubmit} noValidate>
        <Field
          label="Email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {reset.isError && (
          <p className="text-[13px] text-brick-danger mb-3">
            Non sono riuscito a inviare il link. Riprova fra qualche istante.
          </p>
        )}
        <Button type="submit" variant="primary" full disabled={reset.isPending}>
          {reset.isPending ? "Invio…" : "Inviami il link"}
        </Button>
      </form>
    </AuthLayout>
  );
}
